<style>    

@page:left {
  @bottom-left {
    content: "Page " counter(page) " of " counter(pages);
  }
}
table, th, td {
    border: 1px solid  black ;
    padding: 2px 4px 2px 4px;
}
</style>
<template>
    <div>
        <div class="page-number"></div>
    <!--div v-on:click="generateReport()">hello</div-->
    <!--div class="divFooter"> hello</div-->
    <div class="m2 mt-5" ref="pdf_top" id="pdf_top">
    <center><img style="max-width: 300px" :src="formSchema.schema.formAttributes.logo" /></center>
        <center><h1 style="margin: 100px 0px 100px;" :style="'color: ' + primaryColour">{{formSchema.schema.formAttributes.description}}</h1></center>
        <!--div style="page-break-inside:avoid;page-break-after:always"></div-->
        <div :key="idx.id" v-for="idx in formSchema.schema.body.groups"> <!-- LOOP OVER GROUPS -->
        <div style="padding: 5px;" v-if="checkRule('visibility',idx.id,formSchema.rules[idx.id], tempValues, formSchema.validation,  'Group: ' + idx.text)">
           
           <div style="font-size: 28px; page-break-before: always"></div>
           <hr>
          
           <div style="width: 100%;" > 
            <center><h2>{{idx.text}}</h2></center>
           </div>
           <hr>
           <div class="form-inline mt-4" style="display: flex; align-items: stretch">
            <div :class="fieldVal.class" valign="middle" :key="fieldVal.id" v-for="fieldVal in idx.fields" > <!-- LOOP OVER FIELDS IN GROUPS -->
              <div class="my-2" v-if="checkRule('visibility',fieldVal.id,formSchema.rules['body'+':'+idx.id+':'+fieldVal.id], tempValues, formSchema.validation, 'Field : ' + fieldVal.text )"><!-- style="page-break-inside : avoid" -->
                <b v-if="!['label','markdown'].includes(fieldVal.type)" class="mb-3" style="vertical-align: top;" >{{fieldVal.text}}</b>
                <div v-if="['label'].includes(fieldVal.type)">
                  <a v-html="formSchema.validation['body'+':'+idx.id+':'+fieldVal.id].optionList"></a>
                </div>
                <div v-if="['markdown'].includes(fieldVal.type)">
                  <a v-html="applyCalcsFromString(formSchema.validation['body'+':'+idx.id+':'+fieldVal.id].optionList)"></a>
                </div>
                <div v-else-if="['signature'].includes(fieldVal.type)">
                    <img style="max-width: 300px" v-if="tempValues['body'+':'+idx.id+':'+fieldVal.id]" :src="tempValues['body'+':'+idx.id+':'+fieldVal.id].value">
                </div>
                <div v-else-if="['checkbox'].includes(fieldVal.type)">
                    <a v-if="tempValues['body'+':'+idx.id+':'+fieldVal.id]">{{tempValues['body'+':'+idx.id+':'+fieldVal.id].value}}</a>
                </div>
                <div v-else-if="['addressSearch'].includes(fieldVal.type)">
                    <a v-if="tempValues['body'+':'+idx.id+':'+fieldVal.id]">{{tempValues['body'+':'+idx.id+':'+fieldVal.id].value.typedValue}}</a>
               </div>
                <div v-else>
                    <a v-if="tempValues['body'+':'+idx.id+':'+fieldVal.id]">{{tempValues['body'+':'+idx.id+':'+fieldVal.id].value}}</a>
               </div>
              </div>
            </div>
             </div>  <!-- wrapper for group checkrule -->
          </div>
        </div>
    </div>
</div>
</template>

<script>
import jsPDF from 'jspdf'
import axios from 'axios'
import jarvis from '../../components/Mixins/JARVIS'
export default { 
    mixins: [jarvis],
    mounted () {
        for(var i=0; i< this.formValues.data.length; i++){
            this.$set(this.tempValues,this.formValues.data[i].formFieldName, JSON.parse(this.formValues.data[i].formFieldData))
        }
},
methods: {
    generateReport () {
        var doc = new jsPDF('p', 'pt', 'a4')

        doc.setFontSize(10)
        var element = document.getElementById("pdf_top");
        var elementHtml = element.outerHTML;
      var getContent = "<div style='font-size:0.8em; border:1px solid; padding: 05px 15px; width: 565px'>"+elementHtml+"</div>" 
            doc.html(getContent, {
                callback: function (doc) {
                    doc.save('test' + '.pdf')
                },margin: [50, 8, 15, 8],
                autoPaging: 'text',
                x: 10,
                y: 10
             });

    },
    applyCalcsFromString (markdownText) { // loop through markdown text and generate calc string to be calculated
    console.log("Markdown Text: ",markdownText)
      let variable = ''
      let foundVars = false
      let novarExpression = ''
      while (markdownText.includes('[[') && markdownText.includes(']]')) {
        novarExpression = novarExpression + markdownText.substring(0, markdownText.indexOf("[["))
        markdownText = markdownText.substring(markdownText.indexOf("[["), markdownText.length)
        variable = markdownText.substring(2, markdownText.indexOf("]]"))
        foundVars = true
        markdownText = markdownText.substring(markdownText.indexOf("]]")+2, markdownText.length)
        novarExpression = novarExpression  + this.calcVariableValue(variable)
      }
      novarExpression = novarExpression + markdownText
      if (foundVars) {
      //  console.log(novarExpression)
      }
      return novarExpression
    },
    calcVariableValue (novarExpression) {  // can contain variable names and values
      let txt = new DOMParser().parseFromString(novarExpression, "text/html") // decode html encoding
      let varValue = this.applyGenericRule (txt.documentElement.textContent, this.tempValues, this.formSchema.rules, this.formSchema.validation, 'test','markdown - formula')
      return varValue
    },
    async getFormSavedValues () { // retrieve FormValues from BE
       const urlpath = this.domain + this.tenantId + '/formshare/' + this.$route.query.token + '/data'
 
       await axios.get(urlpath, {
         headers: {
           'Content-Type': 'application/json',
           'Authorization': this.$route.query.auth 
         }
       })
       .then((response) => {
         this.sharedbyDetail = response.data.formShareHeader
         if (response.data.presetFieldValues) { //this.tenantId === 'testtenant' &&
          this.presetFieldValues = JSON.parse(response.data.presetFieldValues)
         }
         //response.data.presetFieldValues
         if (response.status !== 200) {
           alert(response.data)
         } else {
           this.readonlyForm = this.sharedbyDetail.state !== 'Active' || 
             (this.sharedbyDetail.formShareState !== 'Active' && this.sharedbyDetail.formShareState !== 'Draft')
           var tempData = response.data.data
           var tempValues = {}
           this.formValuesVersion = {}
           var i = 0
           for(i=0; i< tempData.length; i++){
             this.$set(tempValues,tempData[i].formFieldName, JSON.parse(tempData[i].formFieldData))
             this.$set(this.formValuesVersion,tempData[i].formFieldName,tempData[i].latestVersion)
           }
           this.formValues = tempValues
         }
       })
       .catch((err) => {
         console.log(err)
         this.readonlyForm = true
       })
     }

},
     data () {
        return {
            tempValues: {},
      }
    }
}
</script>